import axios from "../../config/axios";
import {
  FETCH_INVESTIGATOR_MANAGEMENT_FAILURE,
  FETCH_INVESTIGATOR_MANAGEMENT_REQUEST,
  FETCH_INVESTIGATOR_MANAGEMENT_SUCCESS,
} from "./types";

export const fetchInvestigatorManagementDetailSuccess = (model) => {
  return {
    type: FETCH_INVESTIGATOR_MANAGEMENT_SUCCESS,
    payload: model,
  };
};
export const fetchInvestigatorManagementDetailFailure = (error) => {
  return {
    type: FETCH_INVESTIGATOR_MANAGEMENT_FAILURE,
    payload: error,
  };
};

export const getInvestigatorManagementDetail = (currentPage, pagelimit) => async (dispatch) => {
  // dispatch(fetchCATTLEDetailRequest);
  await axios
    .post(`investigator/listInvestigator/?page=${currentPage}&limit=${pagelimit}`)
    .then((response) => {
      if (response.status) {
        const result = response.data;
        dispatch(fetchInvestigatorManagementDetailSuccess(result));
      }
    })
    .catch((error) => {
      const errorMsg = error.message;
      dispatch(fetchInvestigatorManagementDetailFailure(errorMsg));
    });
};